module.exports = __webpack_public_path__ + "resources/img/img_datatransporter_v2.424d2fa6f68dc3d8e43db9695f6f3c7b.png";